var map = {
	"./BNP_Paribas.png": 48,
	"./fraqtory.svg": 49,
	"./innova.png": 50,
	"./ipc.png": 51,
	"./jeeurope.png": 52,
	"./myelin8.jpg": 53,
	"./nttdata.png": 54,
	"./preciouscontrol.png": 55,
	"./sky.png": 56,
	"./ubuntu.png": 57,
	"./xiaomi.png": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;